var map = {
	"./ambassador.svg": "8252",
	"./angel.svg": "1753",
	"./baby-angel.svg": "5b38",
	"./elite-map-maker.svg": "5278",
	"./guard-angel.svg": "e9b9",
	"./knight-angel.svg": "0540",
	"./map-maker.svg": "ea10",
	"./map-validator.svg": "3e8e",
	"./newbie-map-maker.svg": "77ad",
	"./royal-angel.svg": "44bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "352d";